import React from 'react';
import { Grid, Box, Paper, Card, CardMedia, Typography } from '@mui/material';
//import SearchPanel from '../SearchPanel'
//import { connect } from 'react-redux';
import ResultItem from './ResultItem'
import ResultItemFavorite from './ResultItemFavorite'
import Instructions from './Instructions'


import { PAGE_CONSTANT_STYLES } from '../page-constants.jsx'
const PAGE_PANEL_COLOR = PAGE_CONSTANT_STYLES.page_panel_color

const DETAILS_BACKGROUND_COLOR = PAGE_CONSTANT_STYLES.details_background_color
const DETAILS_TEXT_COLOR = PAGE_CONSTANT_STYLES.details_text_color

import Collapse from "@mui/material/Collapse";
import CardHeader from "@mui/material/CardHeader";
import Container from "@mui/material/Container";
import CardContent from "@mui/material/CardContent";

import Add from
    "@mui/icons-material/Add";
import Remove from
    "@mui/icons-material/Remove";

import IconButton from "@mui/material/IconButton";



const StyledAddIcon = () => (
    <div style={{
        width: '100%', display: 'flex', justifyContent: 'center',
        padding: '0rem', margin: '0rem',
    }}>
        <Add
            sx={{
                mx: 2, width: '2rem', height: '2rem',
                color: DETAILS_TEXT_COLOR, //'#034488', 
                padding: '0rem', margin: '0rem',
            }}
        >
        </Add>
    </div>
);
const StyledRemoveIcon = () => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Remove
            sx={{
                mx: 2, width: '2rem', height: '2rem',
                color: DETAILS_TEXT_COLOR, // '#034488', 
                padding: '0rem', margin: '0rem',
            }}
        >
        </Remove>
    </div>
);















import { useState, useEffect, useRef } from 'react';

import { useMemo, useCallback } from 'react';
















const ButtonBox = (props) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            paddingTop: '0.5rem',
            width: '100%',
            justifyContent: 'center',
            //backgroundColor: 'black',
            padding: '0rem',

        }}
    >
        {props.children}
    </Box>
);

const StyledBox = (props) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: "no-wrap",
            justifyContent: "space-between",
            width: 'auto',

            backgroundColor: PAGE_PANEL_COLOR, // '#011552',
            opacity: '1.00',
            paddingLeft: '0rem', // '0.5rem',
            marginLeft: '1.5rem', //'1rem',

            // backgroundColor: '#011552',
            // opacity: '1.00',
            // paddingLeft: '0.5rem',
            // marginLeft: '1rem',
            marginRight: '1rem',
            padding: '0rem',

        }}
    >
        {props.children}
    </Box>
);


const InstructionTypography = (props) => (
    <Typography
        sx={{
            borderRadius: '5px',
            align: "center",
            fontSize: '1.2rem',
            fontWeight: 'bold',
            backgroundColor: '#edece8',
            color: 'black',
            margin: '0.5rem',
            opacity: '0.8',
            // marginTop:'0rem',
            // marginBottom:'1rem',
            padding: '5px',

        }}
    >
        {props.children}
    </Typography>
);

















const SearchResults = (props) => {




    const [open2, setOpen2] = useState(false);









    const { sendActionToPage } = props
    const { favoritesData } = props
    let favoritesDataDisplayItemsLength = favoritesData.itemData.length
    let favoritesDataDisplayItemsLengthString = 'Favorites List ' + favoritesData.itemData.length.toString()

    function handleActionPanel(passObject) {

        //console.log(elementData)


        // let passObject = {
        //     statusToSet: !isFavorited,
        //     itemData: data,
        // }



        const itemDataAndStatus = {
            selectedType: 'updatefavorites',
            statusToSet: passObject.statusToSet,
            itemData: passObject.itemData,
        }

        // selectedObject: searchObjectInfo.activeSearchObject,
        // selectedSortBy: searchObjectInfo.sortBy,
        // selectedElement: elementTypeAndData.data,


        /// console.log('updatefavorites')

        sendActionToPage(itemDataAndStatus)

    }










    const triggerPointRef = useRef(null); // Ref to the element marking the trigger point

    // Extract data from props
    const { data } = props;
    let default_number_to_render = 50
    const [renderIndex, setRenderIndex] = useState(0);
    let renderDisplayItemsLength = data.wineSearchResultsLength


    const handleReset = useCallback(() => {
        setRenderIndex((renderIndex) => default_number_to_render);
        ///console.log('default_number_to_render Updated renderIndex:', renderIndex); // Log for verification
    }, []);



    // Define the function to compute the memoized value (if applicable)
    const memoizedValue = useMemo(() => {
        // Expensive calculation or logic here (only runs when dependencies change)

        ///console.log('memo---------------')

        // setRenderIndex(default_number_to_render)
        handleReset()
        return data.wineSearchResults; // Example calculation


    }, [data.wineSearchResults]); // Dependency array




    // Define the function to compute the memoized value (if applicable)
    const memoizedValue2 = useMemo(() => {
        // Expensive calculation or logic here (only runs when dependencies change)


        // console.log('memo---------------')
        // console.log("triggerPointRef.current 4 ", triggerPointRef.current)


        return memoizedValue.slice(0, renderIndex); // Example calculation
    }, [renderIndex, memoizedValue]); // Dependency array






    // console.log('memoizedValue ', memoizedValue)
    // console.log('memoizedValue2 ', memoizedValue2)

    // useEffect(() => {
    //     console.log('Updated renderIndex:--------------', renderIndex);
    //     console.log('memoizedValue ', memoizedValue)
    //     console.log('memoizedValue2 ', memoizedValue2)
    // }, [renderIndex]);








    const handleIntersection = useCallback((entries) => {
        setRenderIndex((renderIndex) => renderIndex + 25);
        // console.log('Updated renderIndex:', renderIndex); // Log for verification
    }, []);

    useEffect(() => {


        const observer = new IntersectionObserver(handleIntersection, {
            root: null, // Observe within the viewport
            rootMargin: '0px 0px -100px 0px', // Observe bottom 100px of viewport
            threshold: 0 // Trigger when 100% of the element is visible
        });


        if (triggerPointRef.current) {
            observer.observe(triggerPointRef.current);
        }
        return () => observer.disconnect(); // Cleanup
    }, []); // Observe changes to triggerPointRef




















    const [favoritesLabel, setFavoritesLabel] = useState(favoritesDataDisplayItemsLengthString);

    useEffect(() => {

        let favoritesDataDisplayItemsLengthString2 = ' Favorite Items - ' + favoritesData.itemData.length.toString()
        setFavoritesLabel(favoritesDataDisplayItemsLengthString2)

    }, [favoritesDataDisplayItemsLength]); // Observe changes to triggerPointRef














    return (
        <div id="inspect_this_div"
            style={{
                width: '100%',
                marginTop: '0rem',
                marginBottom: '2rem',
                display: 'flex',
                flexDirection: 'row', justifyContent: 'center', flexWrap: "wrap",
                padding: '0rem',
            }}>
            <Grid container spacing={2}>
                <ButtonBox>
                    <Grid item xs={12} sm={8} md={6} >
                        <StyledBox>
                            <div id="inspect_this_div_2" style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                                flexWrap: "wrap",
                                borderWidth: '2px',
                                borderColor: '#edece8',
                                borderStyle: 'solid',
                                // paddingBottom: '1rem',
                                marginBottom: '0rem',
                                padding: '0rem',
                            }}>
                                <div style={{
                                    width: '100%', height: 'auto'
                                }}
                                >

                                    {/* <Typography
                                        //borderRadius='5px'
                                        align="center"
                                        fontSize='1.5rem'
                                        fontWeight='bold'
                                        // backgroundColor='#edece8'
                                        color='black'
                                        margin='0rem'
                                        marginTop='0rem'
                                        padding='5px'
                                        borderRadius='0px'
                                        fontFamily='imported-font-result-text-name'

                                    >
                                        Favorites List
                                    </Typography> */}












































                                    <style>

                                        {`




.fade {
opacity: 1;
transition: opacity 0.3s ease;
}

.visible {
opacity: 1;
}

.hidden {
opacity: 0;
}






`}

                                    </style>


                                    <Card sx={{

                                        minWidth: 300,
                                        //border: "6px solid black", //"4px solid rgba(211,211,211,0.6)",

                                        backgroundColor: PAGE_PANEL_COLOR, //  DETAILS_BACKGROUND_COLOR, //'#8dbbe6', // RESULT_ITEM_BACKGROUND_COLOR, //RESULT_ITEM_COLOR, 
                                        // '#011552' //'#edece8'
                                        // 74acdf   ccdde8  8dbbe6  609cd4


                                        color: DETAILS_TEXT_COLOR, //RESULT_ITEM_COLOR, //RESULT_ITEM_TEXT_COLOR, 
                                        //'white'

                                        //backgroundColor: 'gray',
                                        borderRadius: '0px',
                                        opacity: '100%',
                                        margin: '0rem',
                                        // marginTop: '0.5rem',
                                        padding: '0rem',
                                        // borderWidth: '1rem',
                                        borderColor: 'black',
                                        // borderRadius: '0.5rem',
                                        fontSize: '1rem',
                                        boxShadow: '2px 2px 5px rgba(03, 44, 88 0.5)',
                                        padding: '0rem',

                                    }}>

                                        <CardHeader

                                            onClick={() => setOpen2(!open2)}
                                            aria-label="expand"
                                            size="medium"



                                            titleTypographyProps={{
                                                fontFamily: 'imported-font-result-text',
                                                fontSize: "1.7rem", fontWeight: 'bold', textAlign: 'left',
                                            }}
                                            title={favoritesLabel} // {"Favorites List"}

                                            action={

                                                <IconButton
                                                    onClick={() => setOpen2(!open2)}
                                                    aria-label="expand"
                                                    size="small"
                                                ///// backgroundColor= "rgba(211,211,211,0.4)"
                                                >

                                                    {open2 ? <StyledRemoveIcon />
                                                        : <StyledAddIcon />}

                                                </IconButton>
                                            }

                                        // style={{
                                        //     padding: '0rem', margin: '0rem', 
                                        // }}
                                        
                                        >

                                        </CardHeader>
                                        <div style={{
                                            padding: '0rem', margin: '0rem', // backgroundColor: '#8dbbf6',
                                            ///// backgroundColor: "rgba(211,211,211,0.4)"   '#8dbbf6',
                                        }}>


                                            <Collapse in={open2} timeout={0}
                                                unmountOnExit

                                                style={{
                                                    padding: '0rem', margin: '0rem', border: '0rem' //, backgroundColor: '#aadff6',
                                                }}

                                            >
                                                <CardContent
                                                    style={{
                                                        padding: '0rem', margin: '0rem', border: '0rem', /// backgroundColor: '#aadff6',
                                                    }}
                                                >
                                                    <Container



                                                        sx={{
                                                            height: 'auto',
                                                            lineHeight: 0,
                                                            width: '100%',
                                                            padding: '0rem',
                                                            margin: '0rem',

                                                            ////backgroundColor: 'yellow',

                                                        }}>



                                                        {/* {open2 && (
                    <> */}




                                                        {/* {item.map((foodItem) => ( */}














                                                        <div
                                                            style={{
                                                                padding: '0rem',
                                                                paddingTop: '0rem',
                                                                //borderWidth: '10px',
                                                                //backgroundColor: 'black'
                                                            }}
                                                        >
                                                            {/* <div  className={`fade ${open2 ? 'visible' : 'hidden'}`} key={foodItem.dish_name}> */}


                                                            {/* <Typography align={'justify'} style={{fontWeight: 'bold', }}>

                        DESCRIPTION

                    </Typography> */}

                                                            {/* <Typography align='center'
                                                                sx={{
                                                                    fontFamily: 'imported-font-result-text',
                                                                    fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem'
                                                                }}
                                                            >DESCRIPTION
                                                            </Typography> */}







                                                            {favoritesData.itemData.length > 0 ? (

                                                                favoritesData.itemData.map((item, index) => (
                                                                    <ResultItemFavorite
                                                                        key={`displayFavoriteItem_${index}`}
                                                                        id={index + 1}
                                                                        data={item}
                                                                        stylr={{padding:'0rem'}}
                                                                        renderDisplayItemsLength={favoritesDataDisplayItemsLength}
                                                                        handleAction={handleActionPanel}
                                                                        favoritesData={favoritesData}
                                                                    ></ResultItemFavorite>
                                                                ))

                                                            ) : (
                                                                <Typography>No Items in Favorites</Typography>
                                                            )}
















                                                            {/* <FoodItem foodItem={foodItem} open={open2}  /> */}
                                                        </div>

                                                        {/* 
In 1900, when Georges de Latour's wife, Fernande, first laid eyes on the land that would become their original Rutherford vineyard, she named it "beau lieu," or "beautiful place." Shortly thereafter, de Latour sold his thriving cream of tartar business, bought the four-acre ranch and founded Beaulieu Vineyard with the vision of making Napa Valley wines that would rival those of his native France.De Latour quickly made a name for himself by importing Phylloxera-resistant rootstock from Europe to the recently-ravaged fledgling California wine industry. He also began selling wine to the Catholic Church, establishing a strong relationship that would allow Beaulieu Vineyard to become the only Napa Valley winery to remain in business during Prohibition.In fact, during Prohibition the winery increased its business. After the repeal in 1933, de Latour began searching for someone who could contribute European winemaking expertise. In 1938, he traveled to France and returned with André Tchelistcheff, famed viticulturist and enologist who instituted the philosophy of continuous innovation in vineyard and winery to which we remain dedicated today. Tchelistcheff introduced cold fermentation for white wines, malolactic fermentation for reds and aging red wines in small, French oak barrels. He also tasted the de Latour family's private wine-what they called "Private Reserve"-from the 1936 vintage. This Cabernet Sauvignon-based wine was so distinctive that Tchelistcheff insisted it be bottled and sold as the winery's flagship offering. The result was the inaugural release of Georges de Latour Private Reserve Cabernet Sauvignon, a wine that was destined to become Napa Valley's first "cult" Cabernet.Today we continue to turn to innovative practices to craft wines in our bold, classic style. We have become a leader in clonal research, and our BV Clone Reserve Cabernet Sauvignon wines are highly acclaimed. Most recently we completed a new state-of-the-art winery within one of our original buildings. The Georges de Latour Private Reserve Winery utilizes the latest technology in combination with time-honored traditions for the production of this exceptional, wine-the longtime benchmark of Rutherford Cabernet.#1 wine for 2022
                    */}

                                                        {/* ))} */}


                                                        {/* </>
                )} */}

                                                        {/* {!open2 && (
                    <>
                        {item.map((foodItem) => (
                            <div key={foodItem.dish_name} style={{height: '2rem'}}>
                                
                            </div>
                        ))}
                    </>
                )} */}





                                                    </Container>
                                                </CardContent>
                                            </Collapse>


                                        </div>
                                    </Card>






























































                                    {/* {favoritesData.itemData.map((item, index) => (
                                        <ResultItemFavorite
                                            key={`displayFavoriteItem_${index}`}
                                            id={index + 1}
                                            data={item}
                                            renderDisplayItemsLength={favoritesDataDisplayItemsLength}
                                            handleAction={handleActionPanel}
                                            favoritesData={favoritesData}
                                        ></ResultItemFavorite>
                                    ))} */}





                                </div>


                            </div>
                        </StyledBox>
                    </Grid >
                </ButtonBox>
            </Grid >

            <div ref={triggerPointRef} id='triggerPointRef' style={{ visibility: 'hidden', height: 1 }}  >

                {/* 
                
                style={{ visibility: 'hidden', height: 1 }} 
                style={{height: "200px" }}
                
                */}

                Load More
            </div>

        </div >
    );
    //}
};

export default SearchResults;


